import { AfterViewInit, Component, viewChild } from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';
import { AutoComplete } from 'primeng/autocomplete';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { FormlyModule } from '@ngx-formly/core';

@Component({
  selector: 'app-formly-payroll-autocomplete',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, AutoComplete, FormlyModule],
  template: `
    <div class="field">
      <label [for]="field.key" class="block mb-2" *ngIf="to.label">
        {{ to.label }}
        <span *ngIf="to.required" class="text-red-500">*</span>
      </label>
      <p-autocomplete
        #autoCompleteObj
        [forceSelection]="true"
        [suggestions]="to.suggestions"
        [formControl]="formControl"
        [formlyAttributes]="field"
        [field]="'displayLabel'"
        [dropdown]="false"
        [style]="{ width: '100%' }"
        (onSelect)="to.onSelect($event)"
        (completeMethod)="to.searchObject(to, $event, field)"
        placeholder="Keresés név vagy azonosító alapján...">
        <!-- Custom template az opciók megjelenítéséhez -->
        <ng-template let-item pTemplate="item">
          {{ item.displayLabel }}
        </ng-template>
      </p-autocomplete>
    </div>
  `,
})
export class FormlyPayrollAutoCompleteComponent extends FieldType<FieldTypeConfig> {
  readonly autoComplete = viewChild<AutoComplete>('autoCompleteObj');
}
